import { render, staticRenderFns } from "./config-tab.vue?vue&type=template&id=c60b823a&scoped=true"
import script from "./config-tab.vue?vue&type=script&lang=js"
export * from "./config-tab.vue?vue&type=script&lang=js"
import style0 from "./config-tab.vue?vue&type=style&index=0&id=c60b823a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60b823a",
  null
  
)

export default component.exports